<script setup lang="ts">
  import { RouterView } from 'vue-router';
</script>

<template>
  <main style="height: 100vh">
    <RouterView v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </RouterView>
  </main>
</template>

<style scoped>
  /* Transición de desvanecimiento */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.1s ease-in-out; /* Aseguramos que la transición dure 0.5 segundos */
  }

  /* En Vue 3 la clase inicial de entrada es .fade-enter-from (no .fade-enter) */
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0; /* La opacidad de las vistas será 0 al principio y al final */
  }
</style>
